import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

const root = document.getElementById('root')
if (!root) {
  throw new Error('Root element not found')
}

// Loading spinner'i kaldir
const loading = document.getElementById('loading')
if (loading) {
  loading.style.display = 'none'
}

ReactDOM.createRoot(root).render(<App />)
